module.exports = __webpack_public_path__ + "media/images/web/home/index/and_more-e8dddc56b67ee4200bf7c160ea2aa9ea.webp";